var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',_vm._g(_vm._b({ref:"editor",class:['app-code-mirror', {'read-only': _vm.options.readOnly }]},'codemirror',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }